import { Component, OnInit, ViewChild } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { RequisitionTestDataService } from '../../data-services/requisitionTest.service';
import { ResultSigningDataService } from '../../data-services/resultsigning.service';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { LocalRequistionService } from '../../data-services/local-requisition.service';
import { RequisitionEditDialogComponent } from '../common/editRequisition.dialog.component'
import { trigger, state, style, animate, transition } from '@angular/animations';
import { FacilityDto } from '../../models/facility-dto';
import { ProviderSearchDto } from '../../models/provider-search-dto';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { SignResultsTestComponent } from './signResults.test.component';

@Component({
  selector: 'app-signresults-list',
  templateUrl: './signResults.list.html',
  providers: [MessageService],
  imports: [ButtonModule, FormsModule, Toast, CommonModule, TableModule, SelectModule, DatePickerModule, SignResultsTestComponent]
})
export class SignResultsListComponent implements OnInit {

  constructor(
    private requisitionTestService: RequisitionTestDataService,
    private messageService: MessageService,
    private resultSigningService: ResultSigningDataService,
    private requisitionService: RequisitionDataService,
    private localReqService: LocalRequistionService) {
  }

  @ViewChild('requisitionEditDialog') requisitionEditDialog: RequisitionEditDialogComponent;
  initialLoad: boolean;
  searchDisabled: boolean = true;
  dataRows: any[];
  totalRecords: any;
  cols: any[];
  loading: boolean;
  showSpinner: boolean = false;
  editRequisitionModalVisible: boolean = false;

  selectedRow: any = null;
  selectedAccession: string = null;
  selectedResultId: number = null;
  lastLoad: any = {};
  gridFilter: any = "";
  public range = { start: null, end: null };
  facilityList: FacilityDto[] = [];
  facilityListFiltered: FacilityDto[] = [];
  providerSearch: any = {
    FirstName: "",
    LastName: "",
    NPI: ""
  };
  labTestList: any[];

  providerSearchList: ProviderSearchDto[] = [];
  providerSearchDto: ProviderSearchDto;

  ngOnInit() {
    this.cols = [
      { field: 'Accession', header: 'Sample ID' },
      { field: 'PatientFirstName', header: 'First Name' },
      { field: 'PatientLastName', header: 'Last Name' },
      { field: 'PatientBirthDate', header: 'Birth Date' },
      { field: 'ProviderName', header: 'Provider' },
      { field: 'FacilityName', header: 'Facility' },
      { field: 'CollectionDate', header: 'Collection Date' },
      { field: 'TestName', header: 'Test' },
      { field: 'StatusText', header: 'Status' },
      { field: 'ReportedDate', header: 'Report Date' },
    ];
    this.loading = false;
    //this.loadGridData(null);
    //this.initialLoad = true;
    this.providerSearch = {};
    this.providerSearch.FirstName = "";
    this.providerSearch.LastName = "";
    this.providerSearch.NPI = "";

    //this.facilityService.getFacilities().subscribe((data: any) => {
    //  this.facilityList = data;
    //  var emptyFacility: FacilityDto = { FacilityName: ' ', Id: 0, SalesRepStartDate: new Date(), AccountType: '', FacilityCode: '', SalesRep: '', ClientId: 0 };
    //  this.facilityList.unshift(emptyFacility);
    //  this.facilityListFiltered = this.facilityList;
    //});

    //this.labService.getAllTests().subscribe((data: any) => {
    //  this.labTestList = data;
    //  this.labTestList.unshift({ Name: ' ' });
    //});


  }

  filterDOBDate: Date;
  filterResultsReceivedDates: Date[];
  filterReportedDates: Date[];
  filterAccession: string = '';
  filterPatientFirstName: string = '';
  filterPatientLastName: string = '';
  filterPatientBirthDate: string = '';
  filterProviderName: string = '';
  filterFacilityName: string = '';
  filterTestName: string = '';
  filterStatusText: string = '';
  dobFilterStart: Date;
  dobFilterEnd: Date;
  filterReviewedBy: string = '';

  dateInputSize: string = 'small';
  statusList: any[] = [
    { status: ' ' },
    { status: 'Repeat Tests' },
    { status: 'Received' },
    { status: 'In Transit to Lab' },
    { status: 'In transit Resolve' },
    { status: 'Exception' },
    { status: 'Sent To Lab' },
    { status: 'Resolved' },
    { status: 'Loaded In Rack' },
    { status: 'Unloaded From Rack' },
    { status: 'Lab Recieved' },
    { status: 'Reported' },
    { status: 'Lab Received' },
    { status: 'Waiting' },
    { status: 'Pending' },
    { status: 'Processing' },
    { status: 'Processed' },
    { status: 'Reporting' },
    { status: 'Completed' }
  ]

  public facilityFilterChange(filter: string): void {
    console.log("FITLER = ", filter);
    if (filter === '' || filter === null) {
      this.facilityListFiltered = this.facilityList;
      return;
    }
    this.facilityListFiltered = this.facilityList.filter(
      (s) => {
        if (s.FacilityCode !== null) {
          return s.FacilityName.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
        }
      }
    );
  }

  private onDOBSelect(e, reqlist) {
    if (this.filterDOBDate) {
      reqlist.filter(this.filterDOBDate.toDateString(), 'DOB', 'contains');
      e.overlayVisible = false;
    }
  }

  private onResultsReceivedRangeSelect(e, reqlist) {
    if (this.filterResultsReceivedDates[1]) {
      reqlist.filter(this.filterResultsReceivedDates[0].toDateString(), 'ResultsReceivedStart', 'contains');
      reqlist.filter(this.filterResultsReceivedDates[1].toDateString(), 'ResultsReceivedEnd', 'contains');
      e.overlayVisible = false;
    }
  }

  private onReportedRangeSelect(e, reqlist) {
    if (this.filterReportedDates[1]) {
      reqlist.filter(this.filterReportedDates[0].toDateString(), 'ReportedStart', 'contains');
      reqlist.filter(this.filterReportedDates[1].toDateString(), 'ReportedEnd', 'contains');
      e.overlayVisible = false;
    }
  }

 public clearAllFilters(reqlist) {
    this.filterAccession = '';
    this.filterPatientFirstName = '';
    this.filterPatientLastName = '';
    this.filterDOBDate = null;
    this.filterProviderName = '';
    this.filterFacilityName = '';
   this.filterResultsReceivedDates = null; 
    this.filterTestName = '';
    this.filterStatusText = '';
    this.filterReportedDates = null;
   this.filterReviewedBy = '';
   this.gridFilter = '';

   reqlist.clear();
  }

  public handleGlobalGridSearchKey(event, gridData) {
    if (event.keyCode == 13) {
      gridData.filterGlobal(event.target.value, 'contains');
      event.preventDefault();
    }
  }

  public handleFilterKey(event, fieldName, gridData) {
    if (event.keyCode == 13) {
      gridData.filter(event.target.value, fieldName, 'contains');
      event.preventDefault();
    }
  }

  public setAllSelect(val) {
    for (var i = 0; i < this.dataRows.length; i++) {
      if (this.dataRows[i].ReviewedBy == null) {
        this.dataRows[i].selected = val;
      }
    }
  }

  public enableSignButton() {
    for (var i = 0; i < this.dataRows.length; i++) {
      if (this.dataRows[i].selected) {
        return true;
      }
    }
    return false;
  }

  public expandRow(row) {
    for (var i = 0; i < this.dataRows.length; i++) {
      if (this.dataRows[i].RequisitionTestId != row.RequisitionTestId) {
        this.dataRows[i].showDetail = false;
      }
    }
    row.showDetail = !row.showDetail;
  }

  public onDateSelect(event, gridData, fieldName) {
    gridData.filter(this.formatDate(event.target.value), fieldName, 'equals')
  }

  formatDate(date) {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }

    return date.getFullYear() + '-' + month + '-' + day;
  }

  public testInfoSaved() {
    this.loadGridData(null);
  }

  public loadGridData(event: LazyLoadEvent) {
    if (event) {
      this.lastLoad = event;
    }
    else {
      this.lastLoad.first = 0;
      this.lastLoad.rows = 20;
      event = this.lastLoad;
    }

    if (this.initialLoad == true) //do not move this code to the top of this function, loadGridData is called by the grid and he passes in the event defaults
    {
      return;
    }

    if (event.sortField == null || event.sortField == '') {
      event.sortField = 'ReceivedFromLIMSDate';
      event.sortOrder = -1;
    }

    this.loading = true;

    this.resultSigningService.searchResultsToBeSigned(event.first, event.rows, event.sortField, event.sortOrder, event.filters).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.dataRows = data.rows;

      for (var i = 0; i < this.dataRows.length; i++) {
        this.dataRows[i].selected = false;
        this.dataRows[i].showDetail = false;
      }

      this.facilityList = [];
      var emptyFacility: FacilityDto = { FacilityName: ' ', Id: 0, SalesRepStartDate: new Date(), AccountType: '', FacilityCode: '', SalesRep: '', ClientId: 0 };
      this.facilityList.unshift(emptyFacility);

      for (var i = 0; i < data.facilities.length; i++) {
        var newFacility: FacilityDto = { FacilityName: data.facilities[i], Id: 0, SalesRepStartDate: new Date(), AccountType: '', FacilityCode: '', SalesRep: '', ClientId: 0 };
        this.facilityList.push(newFacility);
      }

      this.statusList = [];
      this.statusList.unshift({ status: ' ' });

      for (var i = 0; i < data.statuses.length; i++) {
        this.statusList.push({ status: data.statuses[i] });
      }

      this.labTestList = [];
      this.labTestList.unshift({ Name: ' ' });

      for (var i = 0; i < data.testTypes.length; i++) {
        this.labTestList.push({ Name: data.testTypes[i] });
      }

      this.loading = false;
    });
  }

  public getRequisitionTestResultReport(id: number) {
    this.requisitionTestService.getTestResultReport(id).subscribe((response: any) => {
      if (response) {
        let file = new Blob([response], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to retrieve Report PDF ', detail: 'Failed: ' + err.error });
    });
  }

  public signResults(resultId) {
    console.log(`signResults ${resultId}`);
    this.resultSigningService.signResults(resultId).subscribe((data: any) => {
      this.loadGridData(this.lastLoad);
    }, (err) => {
      console.log(`Error: ` + err.error)
      this.messageService.add({ severity: 'error', summary: 'Error approving results', detail: 'Failed: ' + err.error });
    });
  }

  public signResultsBatch() {
    this.loading = true;
    var index = -1;
    for (var i = 0; i < this.dataRows.length; i++) {
      if (this.dataRows[i].selected == true) {
        index = i;
        break;
      }
    }

    if (index > -1) {
      this.resultSigningService.signResults(this.dataRows[index].RequisitionTestResultId).subscribe((data: any) => {
        this.messageService.add({ sticky: false, severity: 'success', summary: 'Successfully approved results for ' + this.dataRows[index].Accession, detail: 'Successful' });
        this.dataRows[index].selected = false;
        this.signResultsBatch();
      }, (err) => {
        console.log(`Error: ` + err.error)
        this.messageService.add({ sticky: true, severity: 'error', summary: 'Error approving results for ' + this.dataRows[index].Accession, detail: 'Failed: ' + err.error });
      });
    }
    else {
      this.loadGridData(this.lastLoad);
    }

  }

  public removeToast() {
    this.messageService.clear();
  }

  showRequisitionEdit: boolean = false;
  requisitionToEdit: any;
  public editRequisition(requisitionId) {
    this.requisitionService.getDetail(requisitionId).subscribe((data: any) => {
      this.requisitionToEdit = data;
      this.localReqService.setRequisition(this.requisitionToEdit);
      this.requisitionEditDialog.InitRequisition();
      this.showRequisitionEdit = true;
    });
  }

  reqRequisitionUpdated() {
    this.showRequisitionEdit = false;
    this.messageService.add({ severity: 'success', summary: 'Requisition Updated' });
  }

  reqRequisitionUpdateFailed(err) {
    this.messageService.add({ severity: 'error', summary: 'Requisition Update Failed', detail: err });
  }

  cancelEditRequisition() {
    this.showRequisitionEdit = false;
  }
}
